<div class="py-4 container-fluid disb-cert-page">
  <h4 class="mb-4 disb-cert-title">{{ pageTitle }}</h4>

  <!-- แถบแท็บบนสุด — ผู้บริหารที่สอนจริงสลับระหว่างใบของตัวเองกับงาน ส่วนการเงิน
       สลับระหว่างเอกสารรายคนกับคิวรอบส่งเบิก โดยวางเป็นตัวสลับมุมมองเหนือ content card
       อาจารย์ไม่มีแถบนี้และเห็นหน้าเดิมทุกประการ -->
  @if (showTopTabs) {
    <div
      class="segmented-tabs disb-cert-top-tabs"
      role="tablist"
      aria-label="มุมมองเอกสารส่งเบิก"
    >
      <button
        type="button"
        id="disbCertTabDocs"
        class="segmented-tab"
        role="tab"
        aria-controls="disbCertPanelDocs"
        [attr.aria-selected]="topTab() === 'mine'"
        [class.active]="topTab() === 'mine'"
        (click)="onTopTabChange('mine')"
      >
        {{ docsTabLabel }}
      </button>
      <button
        type="button"
        id="disbCertTabRounds"
        class="segmented-tab"
        role="tab"
        aria-controls="disbCertPanelRounds"
        [attr.aria-selected]="topTab() === 'queue'"
        [class.active]="topTab() === 'queue'"
        (click)="onTopTabChange('queue')"
      >
        {{ queueTabLabel }}
      </button>
      @if (showFinanceCancellationQueue) {
        <button
          type="button"
          id="disbCertTabCancellation"
          class="segmented-tab"
          role="tab"
          aria-controls="disbCertPanelCancellation"
          [attr.aria-selected]="topTab() === 'cancellation'"
          [class.active]="topTab() === 'cancellation'"
          (click)="onTopTabChange('cancellation')"
        >
          ยกเลิกกลุ่มใบปะหน้า
        </button>
      }
    </div>
  }

  <div class="disb-cert-card">
    <div class="disb-cert-card-body">
      <div
        class="disb-cert-toolbar"
        [formGroup]="filterForm"
        [class.disb-cert-toolbar-only]="!showCertificationQueue && !showTopTabs"
      >
        <div class="disb-cert-filter">
          <app-select
            label="เทอมการศึกษา"
            labelSize="compact"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-cert-filter">
          <app-select
            label="ปีการศึกษา"
            labelSize="compact"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        @if (showDepartmentFilter) {
          <div class="disb-cert-filter">
            <app-select
              label="สาขาวิชา"
              labelSize="compact"
              formControlName="departmentId"
              [options]="departmentOptions"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [searchable]="true"
              inputClass="ng-select-size-md"
              classes="mb-0"
            ></app-select>
          </div>
        }

        @if (showSearch) {
          <div class="disb-cert-search">
            <app-filter-search-input
              [label]="searchLabel"
              formControlName="keywords"
              [ariaLabel]="searchLabel"
              classes="mb-0"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>
        }
      </div>

      <!-- Kept outside every tab panel: `static: true` ViewChild reads run before the
           first change detection, so a template inside a control-flow block would be
           undefined by the time initColumns() builds the datatable columns. -->
      <ng-template #statusTemplate let-row="row">
        <app-status-badge
          [tone]="statusDisplay(row.statusCode).tone"
          [label]="statusDisplay(row.statusCode).label"
        />
      </ng-template>

      <ng-template #pendingActionTemplate let-row="row">
        <span class="disb-cert-pending-action">{{ pendingActionLabel(row) }}</span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <button
          type="button"
          class="btn disb-cert-action-button datatable-view-action-button"
          aria-label="ดูใบรับรองการเบิกจ่าย"
          (click)="onView(row)"
        >
          <img
            src="assets/media/icons/svg/eye.svg"
            class="disb-cert-action-icon datatable-view-action-icon"
            alt=""
            aria-hidden="true"
          />
        </button>
      </ng-template>

      @if (showCertificationTable) {
        <div
          id="disbCertPanelDocs"
          class="disb-cert-tab-panel"
          [attr.role]="showTopTabs ? 'tabpanel' : null"
          [attr.aria-labelledby]="showTopTabs ? 'disbCertTabDocs' : null"
        >
          @if (showStatusSubTabs) {
            <div class="segmented-tabs segmented-tabs--sm disb-cert-tabs" role="tablist" aria-label="สถานะใบรับรองการเบิกจ่าย">
              @for (tab of statusTabs; track tab.key) {
                <button
                  type="button"
                  class="segmented-tab"
                  role="tab"
                  [attr.aria-selected]="activeTab() === tab.key"
                  [class.active]="activeTab() === tab.key"
                  (click)="onTabChange(tab.key)"
                >
                  {{ tab.label }}
                </button>
              }
            </div>
          }

          <app-datatable
            [datasource]="datasource()"
            [columns]="columns"
            [isLoading]="tableLoading()"
            [limit]="10"
            [showFooter]="false"
            (sortChange)="onSortChange($event)"
          ></app-datatable>

          <app-table-pagination
            [page]="datasource().page"
            [limit]="datasource().limit"
            [total]="datasource().total"
            [totalPage]="datasource().total_page"
            [offset]="datasource().offset"
            [dataLength]="datasource().data.length"
            [pageSizeOptions]="pageSizeOptions"
            ariaLabel="disbursement certification pagination"
            (pageChange)="onPageChange($event)"
            (limitChange)="onLimitChange($event)"
          ></app-table-pagination>
        </div>
      }

      <!-- v2.0 phase 2 — round-centric queue. อยู่บนแท็บขวาเสมอ: การเงิน/แอดมินสลับมาจาก
           แท็บเอกสารรายคน ส่วนหัวหน้าสาขา / รองคณบดีฝ่ายบริหาร สลับมาจากแท็บเอกสารของฉัน
           หัวข้อ "รอบส่งเบิก" ของคอมโพเนนต์ถูกปิดไว้ — ชื่อแท็บบอกอยู่แล้ว -->
      @if (showRoundQueue) {
        <div
          id="disbCertPanelRounds"
          class="disb-cert-tab-panel"
          role="tabpanel"
          aria-labelledby="disbCertTabRounds"
        >
          <!-- ลำดับ binding มีผลจริง: Angular set input ตามลำดับที่เขียนใน template และ
               แผงนี้ถูก mount ใหม่ทุกครั้งที่สลับมาแท็บนี้ ถ้า [academicTermId] มาก่อน
               ตัว setter ของเทอมจะยิง getRounds โดยยังไม่มีตัวกรอง แล้ว input ถัดไปยิงซ้ำอีกครั้ง
               — สอง request แข่งกัน และผลที่ "ไม่กรอง" อาจกลับมาทีหลังแล้วทับรายการที่กรองแล้ว
               วาง [keywords]/[departmentId] ไว้ก่อนจึงเก็บค่าไว้เฉย ๆ (termId ยังเป็น null)
               แล้วให้ setter ของเทอมโหลดรอบเดียวพร้อมตัวกรองทั้งหมด -->
          <app-disbursement-round-queue
            [keywords]="submittedKeywords()"
            [departmentId]="selectedDepartmentId()"
            [academicTermId]="selectedAcademicTermId()"
            [showHeading]="false"
          ></app-disbursement-round-queue>
        </div>
      }

      @if (showCancellationQueue) {
        <div
          id="disbCertPanelCancellation"
          class="disb-cert-tab-panel"
          role="tabpanel"
          aria-labelledby="disbCertTabCancellation"
        >
          <app-disbursement-cancellation-queue
            [keywords]="submittedKeywords()"
            [departmentId]="selectedDepartmentId()"
            [academicTermId]="selectedAcademicTermId()"
          ></app-disbursement-cancellation-queue>
        </div>
      }
    </div>
  </div>
</div>

@if (detailOpen()) {
  <div class="disb-cert-modal-overlay" role="presentation">
    <div
      class="disb-cert-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disbCertDetailTitle"
    >
      @if (selectedRow(); as row) {
        <div class="disb-cert-detail-header">
          <div class="disb-cert-detail-title">
            <h5 id="disbCertDetailTitle">{{ row.teacherName }}</h5>
            <app-status-badge
              [tone]="statusDisplay(row.statusCode).tone"
              [label]="statusDisplay(row.statusCode).label"
              size="md"
            />
          </div>
          <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseDetail()"></button>
        </div>

        <div class="disb-cert-detail-body">
          <div class="disb-cert-detail-meta">
            <span>เทอมการศึกษา: {{ row.academicTermLabel }}</span>
            <span>สาขาวิชา: {{ row.departmentName }}</span>
            @if (isInternational(row)) {
              <span>อาจารย์ผู้สอน: {{ teacherListLabel(row) }}</span>
            }
          </div>

          @if (row.raw.revision_comment) {
            <div class="disb-cert-revision-block">
              <strong>เหตุผลส่งกลับแก้ไขล่าสุด:</strong>
              <p class="disb-cert-revision-comment">{{ row.raw.revision_comment }}</p>
            </div>
          }

          <div class="disb-cert-stepper" aria-label="ขั้นตอนการอนุมัติ">
            <h6>ขั้นตอนการอนุมัติ</h6>
            <ol class="disb-cert-stepper-list">
              @for (entry of row.raw.approval_track; track entry.station) {
                <li class="disb-cert-stepper-item" [ngClass]="'disb-cert-stepper-' + entry.state">
                  <span class="disb-cert-stepper-role">
                    {{ entry.role_label }}
                    @if (teacherProgressCountLabel(entry); as countLabel) {
                      <span class="disb-cert-stepper-count">{{ countLabel }}</span>
                    }
                  </span>
                  <!-- Round 4: the teacher station of an international cert lists
                       each member's own certify progress as sub-rows. -->
                  @if (hasTeacherProgress(entry)) {
                    <ul class="disb-cert-stepper-teachers">
                      @for (member of teacherProgress(entry); track member.user_id) {
                        <li class="disb-cert-stepper-teacher">
                          <span
                            class="disb-cert-stepper-teacher-mark"
                            [class.certified]="member.certified_at"
                            aria-hidden="true"
                          >{{ member.certified_at ? '✓' : '•' }}</span>
                          <span class="disb-cert-stepper-teacher-name">{{ member.name ?? '-' }}</span>
                          @if (member.certified_at) {
                            <span class="disb-cert-stepper-teacher-date">รับรองเมื่อ {{ formatDate(member.certified_at) }}</span>
                          } @else {
                            <span class="disb-cert-stepper-teacher-pending">รอรับรอง</span>
                          }
                        </li>
                      }
                    </ul>
                  } @else {
                    <span class="disb-cert-stepper-names">{{ stationPersonNames(entry) }}</span>
                  }
                  @if (entry.state === 'done' && entry.acted_at) {
                    <span class="disb-cert-stepper-date">ดำเนินการเมื่อ {{ formatDate(entry.acted_at) }}</span>
                  }
                  @if (entry.state === 'current') {
                    <span class="disb-cert-stepper-current-badge">รอดำเนินการ</span>
                  }
                </li>
              }
            </ol>
          </div>

          <!-- Round 8: the ADR-16 "ใบปะหน้า rides the whole chain" first
               section is REMOVED — see disbursement-certification.component.ts
               for why. -->
          <div class="disb-cert-doc-section">
            <h6>เอกสารส่งเบิก</h6>
            @for (docRow of calcSectionDocRows(row); track docRow.key) {
              <div class="disb-cert-doc-row">
                <button
                  type="button"
                  class="disb-cert-doc-row-header"
                  (click)="onTogglePreview(docRow)"
                >
                  <span>{{ docRow.label }}</span>
                  <span class="disb-cert-doc-row-toggle">{{ isPreviewExpanded(docRow.key) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}</span>
                </button>
                @if (isPreviewExpanded(docRow.key)) {
                  <div class="disb-cert-doc-preview">
                    @if (isPreviewLoading(docRow.key)) {
                      <p class="disb-cert-doc-preview-loading">กำลังสร้างตัวอย่างเอกสาร...</p>
                    } @else if (previewHasError(docRow.key)) {
                      <p class="disb-cert-doc-preview-error">{{ previewErrorMessage(docRow.key) }}</p>
                    } @else {
                      @if (previewUrl(docRow.key); as url) {
                        <iframe
                          class="disb-cert-doc-preview-frame"
                          [src]="url"
                          [title]="docRow.label"
                        ></iframe>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>

          <div class="disb-cert-doc-section">
            <h6>ตารางสอน</h6>
            @for (docRow of scheduleSectionDocRows(row); track docRow.key) {
              <div class="disb-cert-doc-row">
                <button
                  type="button"
                  class="disb-cert-doc-row-header"
                  (click)="onTogglePreview(docRow)"
                >
                  <span>{{ docRow.label }}</span>
                  <span class="disb-cert-doc-row-toggle">{{ isPreviewExpanded(docRow.key) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}</span>
                </button>
                @if (isPreviewExpanded(docRow.key)) {
                  <div class="disb-cert-doc-preview">
                    @if (isPreviewLoading(docRow.key)) {
                      <p class="disb-cert-doc-preview-loading">กำลังสร้างตัวอย่างเอกสาร...</p>
                    } @else if (previewHasError(docRow.key)) {
                      <p class="disb-cert-doc-preview-error">{{ previewErrorMessage(docRow.key) }}</p>
                    } @else {
                      @if (previewUrl(docRow.key); as url) {
                        <iframe
                          class="disb-cert-doc-preview-frame"
                          [src]="url"
                          [title]="docRow.label"
                        ></iframe>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <div class="disb-cert-detail-footer">
          @if (isWindowClosed(row)) {
            <span class="disb-cert-window-closed-note">หมดเขตส่งเบิกแล้ว</span>
          } @else {
            @if (teacherWaitingLabel(row); as waitingLabel) {
              <span class="disb-cert-teacher-waiting">{{ waitingLabel }}</span>
            }
            @if (teacherNotClaimingLabel(row); as notClaimingLabel) {
              <span class="disb-cert-teacher-not-claiming">{{ notClaimingLabel }}</span>
            }
            @if (revisionWindowLabel(row); as windowLabel) {
              <span class="disb-cert-revision-window">{{ windowLabel }}</span>
            }
            @if (canShowRevisionButton(row)) {
              <button
                type="button"
                class="btn disb-cert-revision-button"
                [disabled]="!canOpenRevision(row) || actionLoading()"
                [title]="!canOpenRevision(row) ? revisionDisabledTooltip(row) : ''"
                (click)="onOpenRevisionDialog()"
              >
                {{ revisionButtonLabel() }}
              </button>
            }
            @if (canActPrimary(row)) {
              <button
                type="button"
                class="btn btn-primary disb-cert-primary-button"
                [disabled]="actionLoading()"
                (click)="onOpenPrimaryConfirm()"
              >
                {{ primaryActionButtonLabel(row) }}
              </button>
            }
          }
        </div>
      }
    </div>
  </div>
}

<app-confirm-dialog
  #primaryConfirmDialog
  modalId="disbursementCertificationPrimaryConfirmDialog"
  icon="success"
  [title]="primaryActionDialogTitle()"
  [message]="primaryActionDialogMessage()"
  cancelText="ยกเลิก"
  [confirmText]="primaryActionDialogConfirmText()"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (confirmed)="onConfirmPrimaryAction()"
></app-confirm-dialog>

<app-disbursement-revision-dialog
  #revisionDialog
  modalId="disbursementCertificationRevisionDialog"
  [title]="revisionDialogTitle()"
  [confirmText]="revisionDialogConfirmText()"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (submitted)="onRevisionSubmitted($event)"
  (cancelled)="onRevisionCancelled()"
></app-disbursement-revision-dialog>

<app-confirm-dialog
  #actionSuccessDialog
  modalId="disbursementCertificationSuccessDialog"
  icon="success"
  [title]="successTitle()"
  [message]="successMessage()"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="actionSuccessDialog.close()"
></app-confirm-dialog>
